import { Component, EventEmitter, Input, Output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { HisTableContextDirective } from '../../table/directive/his-table-context.directive';
import { TableConfig } from '../../table/model/table-model';
import { HisSearchResultConfigColumn } from '../model/searchresultconfig/his-search-result-config-column';

export type SearchResultConfigSavedEvent = {
    defaultTablePageSize: number | null;
    frozenCol: string;
    hiddenColsChanged: boolean;
};

type Position = 'top' | 'bottom' | 'both';
@Component({
    selector: 'his-search-result-config',
    templateUrl: './his-search-result-config.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HisSearchResultConfigComponent {

    @Input() configColumns: HisSearchResultConfigColumn[] = [];

    /** Zeilen pro Seite untere Grenze @deprecated */
    @Input() minRows: number;

    /** Zeilen pro Seite obere Grenze */
    @Input() maxRows: number;

    /** Whether to show the paginator config or not */
    @Input() showPaginator: boolean;

    /** Table identifier used for user profile keys and config synchronization */
    @Input() tableId: string;

    @Output() saved = new EventEmitter<SearchResultConfigSavedEvent>();

    /** @deprecated */
    @Input() defaultTablePageSize: number;
    /** @deprecated */
    @Input() paginatorPosition: string;
    /** @deprecated */
    @Output() paginatorPositionChange = new EventEmitter<Position>();
    /** @deprecated */
    @Input() frozenCol: string = 'noneCol';
    /** @deprecated */
    @Input() set userProfileKeyBasePath( value: string ) {
        this.tableId = value;
    }
    /** @deprecated */
    get userProfileKeyBasePath(): string {
        return this.tableId;
    }

    private readonly tableConfigRef = viewChild<any>( 'tc' );
    private readonly tableContext = viewChild<HisTableContextDirective>( 'tableCtx' );

    showTableConfigPopup() {
        this.tableConfigRef().showTableConfigDialog();
    }

    hideEditTablePopup() {
        this.tableConfigRef().hideTableConfigDialog();
    }

    async save() {
        await this.tableConfigRef().apply();
    }

    /**
     * resets (deletes) user profile keys
     * triggered by click on "Standard wiederherstellen"
     */
    async reset() {
        await this.tableConfigRef().reset();
    }

    cancel() {
        this.tableConfigRef().cancel();
    }

    protected onSaved( event: TableConfig ) {
        const hiddenColsChanged = !!this.tableContext().tableConfig().changes?.hiddenCols;
        const result = {
            defaultTablePageSize: event.defaultTablePageSize,
            frozenCol: event.frozenCol,
            hiddenColsChanged
        };
        this.saved.emit( result );

        if ( !!this.tableContext().tableConfig().changes?.paginatorPosition ) {
            this.paginatorPositionChange.emit( event.paginatorPosition );
        }
    }
}
